import type { ReactNode } from "react";
import { formatEuro } from "@shared/geld";

export interface TotalProps {
  /** Betrag in Cent. */
  amountCent: number;
  label?: ReactNode;
  size?: "xl" | "lg" | "md";
  caption?: ReactNode;
  tone?: "success";
}

/** Die Summe – größtes Element in der Kasse. `aria-live` meldet Änderungen. */
export function Total({ amountCent, label = "Summe", size = "xl", caption, tone }: TotalProps) {
  return (
    <div className={["rg-total", `rg-total--${size}`, tone && `rg-total--${tone}`].filter(Boolean).join(" ")}>
      <div className="rg-total__label">{label}</div>
      <div className="rg-total__amount" aria-live="polite">
        {formatEuro(amountCent)}
      </div>
      {caption ? <div className="rg-total__caption">{caption}</div> : null}
    </div>
  );
}
